<div class="auth-container">
  <!-- Step 1:<br>Account setup Two-column layout -->
  <div class="auth-layout" *ngIf="currentStep === 1">
    <!-- Left Side - Sign Up Form -->
    <div class="auth-left">
      <!-- VHI Logo - Top Left (Only visible in step 1) -->
      <div class="auth-logo-header" *ngIf="currentStep === 1">
        <img src="../../../assets/img/vhi_logo.png" alt="Company Logo" />
      </div>
      <div class="form-main-container">
        <div class="auth-form">
          <!-- Step 1:<br>Account setup Account Setup -->
          <div *ngIf="currentStep === 1">
            <h2 class="signup-title">Create an account</h2>
            <p class="signup-subtitle">Sign up to start your Free Trial</p>

            <form [formGroup]="signupForm" (ngSubmit)="startSignup()">
              <div class="form-row">
                <div class="form-group">
                  <input type="text" class="form-control" formControlName="firstName" placeholder="Name" autocomplete="given-name">
                  <div class="text-danger small mt-1" *ngIf="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.invalid">
                    First name is required
                  </div>
                </div>

                <div class="form-group">
                  <input type="text" class="form-control" formControlName="lastName" placeholder="Last name" autocomplete="family-name">
                  <div class="text-danger small mt-1" *ngIf="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.invalid">
                    Last name is required
                  </div>
                </div>
              </div>

              <div class="form-group mb-4">
                <input type="email" class="form-control" formControlName="email" placeholder="Email" autocomplete="email">
                <div class="text-danger small mt-1" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.invalid">
                  Please enter a valid email address
                </div>
              </div>

              <div class="form-group mb-4">
                <div class="input-group">
                  <input 
                    [type]="showPassword ? 'text' : 'password'" 
                    class="form-control"
                    formControlName="password" 
                    placeholder="Create a password" 
                    autocomplete="new-password">
                  <button 
                    type="button" 
                    class="btn btn-outline-secondary" 
                    (click)="showPassword = !showPassword">
                    <i class="bi" [ngClass]="{'bi-eye-fill': !showPassword, 'bi-eye-slash-fill': showPassword}"></i>
                  </button>
                </div>
                <div class="text-danger small mt-1" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.invalid">
                  Password must contain at least 8 characters, including uppercase, lowercase, number and special character
                </div>
              </div>

              <div class="d-grid gap-2 mb-4">
                <button type="submit" class="btn btn-primary btn-lg" [disabled]="signupForm.invalid || loading">
                  <span class="spinner-border spinner-border-sm me-2" *ngIf="loading"></span>
                  Create Account
                </button>
              </div>

              <div class="form-check-container mb-3">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" formControlName="termsAccepted" id="terms">
                  <label class="form-check-label" for="terms">
                    I agree to <a href="https://www.talonic.com/terms" target="_blank" class="text-decoration-underline">Terms and Conditions</a><span class="text-danger">*</span>
                  </label>
                </div>
                <div class="text-danger small mt-1" *ngIf="signupForm.get('termsAccepted')?.touched && signupForm.get('termsAccepted')?.invalid">
                  You must accept the terms and conditions
                </div>
              </div>

              <div class="form-check-container mb-4">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" formControlName="marketingConsent" id="marketing">
                  <label class="form-check-label" for="marketing">
                    I would like to receive regular information, offers, and updates from Talonic by email
                  </label>
                </div>
              </div>
            </form>

            <div class="divider">
              <span>or</span>
            </div>

            <div class="text-center mt-4">
              <p class="text-muted">
                Already have an account? <a routerLink="/auth/signIn" class="text-primary">Sign in</a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Right Side - Gradient Background with Slides -->
    <div class="auth-right">
      <div class="gradient-background">
        <div class="slides-container">
          <div class="slide" [class.active]="currentSlide === 0">
            <img src="../../../assets/img/backgrounds/sign-in-slide-1.svg" alt="Slide 1" />
          </div>
          <div class="slide" [class.active]="currentSlide === 1">
            <img src="../../../assets/img/backgrounds/sign-in-slide-2.svg" alt="Slide 2" />
          </div>
          <div class="slide" [class.active]="currentSlide === 2">
            <img src="../../../assets/img/backgrounds/sign-in-slide-3.svg" alt="Slide 3" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Step 2:<br>Company Info Centered OTP Verification -->
  <div class="centered-step-container" *ngIf="currentStep === 2">
    <div class="centered-step-content">
      <!-- Talonic Logo -->
      <div class="step-logo">
        <img src="../../../assets/img/vhi_logo.png" alt="Talonic Logo" />
      </div>

      <!-- Step Progress -->
      <div class="step-progress">
        <div class="step-container">
          <div class="step-item">
            <div class="step-circle-container">
              <div class="step-number active" data-step="1"></div>
              <div class="step-line"></div>
            </div>
            <span class="step-label">Step 1:<br>Account setup</span>
          </div>
          <div class="step-item">
            <div class="step-circle-container">
              <div class="step-line"></div>
              <div class="step-number active" data-step="2"></div>
            </div>
            <span class="step-label">Step 2:<br>Company Info</span>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="step-content">
        <h2 class="step-title">Verify your email address</h2>
        <p class="step-subtitle">Check your inbox for the verification code.</p>

        <div class="verification-form">
          <div *ngIf="!otpConfirmed">
            <input #otpInput type="text" class="verification-input" 
                   placeholder="Verification code" maxlength="6">
            <button class="continue-btn" 
                    (click)="confirmOTP(otpInput.value)"
                    [disabled]="loading">
              <span class="spinner-border spinner-border-sm me-2" *ngIf="loading"></span>
              Continue
            </button>
          </div>

          <div *ngIf="otpConfirmed" class="verification-success">
            <i class="bi bi-check-circle-fill"></i>
            <p>CONFIRMED</p>
            <button class="continue-btn" (click)="nextStep()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Step 3: Centered Company Info -->
  <div class="centered-step-container" *ngIf="currentStep === 3">
    <div class="centered-step-content">
      <!-- Talonic Logo -->
      <div class="step-logo">
        <img src="../../../assets/img/vhi_logo.png" alt="Talonic Logo" />
      </div>

      <!-- Step 3 Form Container (circles, text, and inputs only) -->
      <div class="step3-form-container">
        <!-- Step Progress -->
        <div class="step-progress">
          <div class="step-container">
            <div class="step-item">
              <div class="step-circle-container">
                <div class="step-number completed" data-step="1"></div>
                <div class="step-line completed"></div>
              </div>
              <span class="step-label">Step 1:<br>Account setup</span>
            </div>
            <div class="step-item">
              <div class="step-circle-container">
                <div class="step-line completed"></div>
                <div class="step-number active" data-step="2"></div>
              </div>
              <span class="step-label">Step 2:<br>Company Info</span>
            </div>
          </div>
        </div>

        <!-- Form Fields -->
        <form [formGroup]="companyForm">
          <div class="form-field">
            <label class="field-label">Company Name</label>
            <input type="text" class="field-input" formControlName="organization" placeholder="" autocomplete="organization">
          </div>

          <div class="form-field">
            <label class="field-label">Your seniority level</label>
            <select class="field-select" formControlName="role">
              <option value=""></option>
              <option *ngFor="let level of seniorityLevels" [value]="level">
                {{level}}
              </option>
            </select>
          </div>

          <div class="form-field">
            <label class="field-label">How did you hear about us?</label>
            <select class="field-select" formControlName="referralSource">
              <option value=""></option>
              <option *ngFor="let source of referralSources" [value]="source">
                {{source}}
              </option>
            </select>
          </div>
        </form>
      </div>

      <!-- Buttons (outside the form container) -->
      <div class="form-actions">
        <button type="button" class="finish-btn" (click)="finalizeSignup()" [disabled]="loading">
          <span class="spinner-border spinner-border-sm me-2" *ngIf="loading"></span>
          Finish
        </button>
        <span class="skip-text" (click)="finalizeSignup()">
          Skip
        </span>
      </div>
    </div>
  </div>
</div>